import {
  ContainerElement,
  IFormDefinition,
  LayoutElement,
} from "@entaconsulting/form";
import resolveLayoutElement from "../components/jsonSchema/resolveJsonElement";

const getLayoutElements = (
  path: string,
  formDefinition: IFormDefinition
): LayoutElement[] | undefined => {
  const _path = path.split("/").slice(1);

  let elements: LayoutElement[];

  if (path.startsWith("body")) {
    const container = resolveLayoutElement(
      formDefinition.layout.elements,
      _path
    ) as ContainerElement;
    elements = container?.elements ?? formDefinition.layout.elements;
  } else {
    const container = resolveLayoutElement(
      formDefinition.layout.header?.elements!,
      _path
    ) as ContainerElement;
    elements = container?.elements ?? formDefinition.layout.header?.elements;
  }

  return elements;
};

export default getLayoutElements;
